import type { MemberCrmIncrementResult } from '@pokerroom/types';
type Storage = Pick<globalThis.Storage, 'getItem' | 'setItem' | 'removeItem'>;
const hash = /^[a-f0-9]{64}$/;
/** A locator only: callers must reauthorize and fetch the receipt from the server. */
export function incrementReceiptHash(storage: Storage, key: string): string | null {
  const value = storage.getItem(key + ':receipt');
  if (value !== null && !hash.test(value)) throw new Error('INCREMENT_RECOVERY_STORAGE');
  return value;
}
export function incrementAttempts(storage: Storage, key: string): string[] {
  const raw: unknown = JSON.parse(storage.getItem(key) ?? '[]');
  if (
    !Array.isArray(raw) ||
    raw.length > 10 ||
    raw.some((v) => typeof v !== 'string' || !hash.test(v)) ||
    new Set(raw).size !== raw.length
  )
    throw new Error('INCREMENT_RECOVERY_STORAGE');
  return raw;
}
export function beginIncrementAttempt(storage: Storage, key: string, planHash: string) {
  if (!hash.test(planHash) || incrementAttempts(storage, key).length)
    throw new Error('INCREMENT_RECOVERY_REQUIRED');
  storage.setItem(key, JSON.stringify([planHash]));
}
export function finishIncrementAttempt(
  storage: Storage,
  key: string,
  planHash: string,
  result: MemberCrmIncrementResult,
) {
  if (
    !result ||
    result.planHash !== planHash ||
    !/^[a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}$/i.test(
      result.batchId,
    ) ||
    typeof result.alreadyConfirmed !== 'boolean'
  )
    throw new Error('INCREMENT_RECEIPT_INVALID');
  const remaining = incrementAttempts(storage, key).filter((h) => h !== planHash);
  storage.setItem(key + ':receipt', planHash);
  if (remaining.length) storage.setItem(key, JSON.stringify(remaining));
  else storage.removeItem(key);
}
